import { Link, useHistory } from 'react-router-dom';
import Pfooter from '../Pfooter';
import '../App.css';
import { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import GlobalVariable from '../GlobalVariable';
import ApiHandler from '../ApiHandler';
import { userActions } from '../store/user-slice';
import { useDispatch } from 'react-redux';
import { variableName } from '../variableName';


export default function Company() {
    const [data, setData] = useState({ username: "", password: "", });
    const [showPassword, setShowPassword] = useState(false);
    const dispatch = useDispatch();


    const changeHandler = (e) => {
        setData({ ...data, [e.target.name]: e.target.value })
    }

    const history = useHistory();

    async function checkUser(e) {

        e.preventDefault();


        let item = {
            userId: data.username,
            password: data.password,
            wclientid: GlobalVariable.wcClient.toString(),

        };
        // let token="";


        ApiHandler.post({
            url: "/api/Com/Authenticate/AuthTokenCom/",
            data: item,

        }
        )
            .then(((result) => {
                console.log(result.data.token)
                if (result.data.isSuccess) {
                    dispatch(userActions.setLogin(true));

                    history.push("/components/company/CompanyDashboard")
                    localStorage.setItem('user-info', JSON.stringify(result.data))
                    // window.localStorage.setItem('loggedIn', true);

                    window.localStorage.setItem("app-type", "Com");
                }
                else {
                    throw result.data;
                }


            }))
            .catch(err => {
                toast.error("wrong username or password");
                console.error(err);
                if (err.response && err.response.status && err.response.status === 401) {
                    console.log(err.response);
                    //   RefreshTokenHandler();
                    //  ToastError("Token has expired Please refresh");
                }
            })





    }
    return (
        <>

            {/* <div className="customer_header">
                <Link to='/'><img src={img2} height={30} width={30} id="S" alt="" style={{ marginTop: "-10px" }} /></Link>
                <h2 style={{ color: "#ea6267", fontWeight: "700", marginTop: "15px" }}>{variableName.outerHeaderName}</h2>
                <img src={R_Logo} height={50} width={50} className="R" alt="" style={{ marginTop: "0px" }} />
            </div> */}

            <form onSubmit={checkUser}>

                <div className='row m-0'>
                    <div className=' p-2  mb-2'>
                        <div className='card border-0 '>

                            <h5 style={{ fontSize: "25px", fontWeight: "500", padding: "10px" }}>Company Login</h5>
                            <div className='p-2'>
                                <label style={{ fontSize: "20px", fontWeight: "400" }}>Rep Id</label><br />
                                <input
                                    name="username"
                                    className='form-control'
                                    onChange={changeHandler}
                                    value={data.username}
                                    id="companyUsername"
                                    type="text"
                                    placeholder='Rep Id' />
                                {/* </div>
                            <div> */}
                                <label style={{ fontSize: "20px", fontWeight: "400" }}>Password</label><br />
                                <div style={{ position: 'relative' }}>
                                    <input
                                        onChange={changeHandler}
                                        className='form-control'
                                        name="password"
                                        value={data.password}
                                        id="companyPassword"
                                        type={showPassword ? 'text' : 'password'}
                                        placeholder='Password '
                                    />
                                    <span
                                        onClick={() => setShowPassword((s) => !s)}
                                        style={{
                                            position: 'absolute',
                                            right: 12,
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            cursor: 'pointer',
                                            color: '#666'
                                        }}
                                        aria-hidden
                                    >
                                        {showPassword ? <FaEyeSlash /> : <FaEye />}
                                    </span>
                                </div>
                                <button
                                    type="submit"
                                    className='btn btn-lg btn-outline-danger  mt-2 w-100'
                                >Sign In</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className='loginForm'></div> */}
            </form>
            {/* <Pfooter /> */}
        </>
    )
}